import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { Services } from './../services-url';

@Injectable({
  providedIn: 'root'
})
export class IndicatorsService {

  constructor(
    private http: HttpClient,
  ) { }

  getIndicators():Observable<any>{
    return this.http.get(Services.indicatorsNacional).pipe(
      tap(events => console.info(`fetched indicators Home`))
    );
  }
}
